import { useState, useCallback } from 'react';
import api from '../api/client';

export function useActivity() {
  const [actions, setActions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchActions = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.actionLog(params);
      const data = response.data?.actions || [];
      setActions(data);
      setHasMore(data.length >= (params.limit || 50));
    } catch (err) {
      setError(err.message || 'Failed to load activity');
    } finally {
      setLoading(false);
    }
  }, []);

  return { actions, loading, error, hasMore, fetchActions };
}

export default useActivity;
